.cell {
  display: flex;
  align-items: center;
  height: 60px;
  background-color: var(--color-surface-primary);
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  flex: 1;
  height: 100%;
}

.text {
  @include caption-regular;

  color: var(--color-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metadata {
  @include metadata-regular;

  color: var(--color-text-tertiary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// Primary type - left-aligned content with optional metadata
.primary {
  .content {
    align-items: flex-start;
  }
}

// Secondary type - right-aligned value
.secondary {
  .content {
    align-items: flex-end;
  }

  .text {
    color: var(--color-text-secondary);
  }
}
